// src/client.ts
import { generateRandomId, isPromise } from "@wix/monitoring-common-sentry";
var PanoramaBrowserClient = class {
  constructor(options) {
    this.options = options;
    this.captureException = (error, captureContext) => {
      const { panoramaClient } = this.options;
      if (!(error instanceof Error)) {
        error = new Error(error);
      }
      panoramaClient.errorMonitor().reportError(error, this.contextToData(captureContext));
    };
    this.captureMessage = (message, captureContext) => {
      const { panoramaClient } = this.options;
      const logger = panoramaClient.logger();
      let loggerByLevel;
      switch (captureContext?.level) {
        case "error":
          loggerByLevel = logger.error;
          break;
        case "warning":
          loggerByLevel = logger.warn;
          break;
        default:
          loggerByLevel = logger.info;
      }
      loggerByLevel(message, this.contextToData(captureContext));
    };
    this.startSpan = (spanOptions, callback) => {
      const { panoramaClient } = this.options;
      const { name } = spanOptions;
      let res;
      const transaction = panoramaClient.transaction(name, {
        id: generateRandomId()
      });
      const data = this.contextToData(spanOptions);
      transaction.start(data);
      try {
        res = callback();
        if (isPromise(res)) {
          res = res.then((_res) => {
            transaction.finish(data);
            return _res;
          }).catch((e) => {
            this.reportErrorInContextOfSpan(e, spanOptions);
            throw e;
          });
        } else {
          transaction.finish(data);
        }
      } catch (e) {
        this.reportErrorInContextOfSpan(e, spanOptions);
        throw e;
      }
      return res;
    };
    this.addBreadcrumb = (breadcrumb) => {
      const { panoramaClient } = this.options;
      panoramaClient.errorMonitor().addBreadcrumb(breadcrumb);
    };
  }
  contextToData(captureContext) {
    return captureContext && {
      ...captureContext?.tags && { tags: captureContext.tags },
      ...captureContext?.contexts && { context: captureContext.contexts },
      ...captureContext?.level && {
        severity: captureContext.level
      }
    };
  }
  reportErrorInContextOfSpan(error, spanOptions) {
    const { panoramaClient } = this.options;
    const { name } = spanOptions;
    const data = this.contextToData({
      ...spanOptions,
      contexts: { transaction: { name } }
    });
    panoramaClient.errorMonitor().reportError(error, data);
  }
  startSpanManual(spanOptions) {
    const { panoramaClient } = this.options;
    const { name } = spanOptions;
    const transaction = panoramaClient.transaction(name, {
      id: generateRandomId()
    });
    const data = this.contextToData(spanOptions);
    transaction.start(data);
    let reported = false;
    const reportOnce = (cb) => {
      if (reported) {
        return;
      }
      reported = true;
      cb();
    };
    return {
      end: () => {
        reportOnce(() => transaction.finish(data));
      },
      fail: (error) => {
        reportOnce(() => this.reportErrorInContextOfSpan(error, spanOptions));
      }
    };
  }
  endSpanManual(spanOptions) {
    const { panoramaClient } = this.options;
    const { name } = spanOptions;
    panoramaClient.transaction(name).finish();
  }
};

// src/factory.ts
import { createFallbackMonitoringClient } from "@wix/monitoring";
var createPanoramaBrowserClient = (options) => {
  const { panoramaClient } = options;
  if (!panoramaClient) {
    return createFallbackMonitoringClient("Missing Panorama client");
  }
  return new PanoramaBrowserClient(options);
};
export {
  createPanoramaBrowserClient
};
